<h1 mat-dialog-title>{{ confirmHeader | uppercase }}</h1>
<div mat-dialog-content>
  <div class="top-margin">
    <div class="yellowHeader" *ngIf="extraMessage">{{ extraMessage }}</div>
    <p class="top-margin">
      <span class="yellowHeader">{{ confirmMessage }}</span>
    </p>
  </div>
</div>
<div mat-dialog-actions>
  <div class="text-center col-md-12">
    <button mat-raised-button *ngIf="showCancelButton" class="cancelbutton" (click)="dialogRef.close(false)">{{ cancelButtonText }}</button>
    <button mat-raised-button class="confirmbutton" (click)="dialogRef.close(true)">{{ confirmButtonText }}</button>
  </div>
</div>
